import React, { Component } from 'react';
import { useEffect, useState, useRef } from 'react';

export default function StickyCorner(props) {
    let corner_ref = useRef(null);
    const [corner_size, setCornerSize] = useState({
        width: 0,
        height: 0,
    });

    useEffect(() => {
        if (corner_ref.current) {
            setCornerSize({
                width: corner_ref.current.offsetWidth,
                height: corner_ref.current.offsetHeight,
            });

            const observer = new ResizeObserver((entries) => {
                for (let entry of entries) {
                    // 'entry.contentRect' contains the new dimensions
                    setCornerSize({
                        width: entry.contentRect.width,
                        height: entry.contentRect.height,
                    });
                    // You can trigger other events or logic here based on the resize
                    console.log('Element resized:', entry.contentRect);
                }
            });

            // Start observing the element
            observer.observe(corner_ref.current);
        }
    }, []);

    return (
        <td
            className="sticky-col sticky-row"
            style={{ padding: '0px' }}
            ref={corner_ref}
            width={props.width}
        >
            <div
                className="sticky-corner"
                style={{
                    width: `${corner_size['width'] + 1}px`,
                    height: `${corner_size['height'] + 1}px`,
                }}
            >
                {props.children}
            </div>
        </td>
    );
}
